import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CreditCardPayment from './PaymentTypes/CreditCard';
import ACHPayment from './PaymentTypes/ACH';
import invoiceDataSelector from '../../selectors/invoice';
import './styles.css';

const PaymentsTile = (props) => {
  const {
    invoiceID,
  } = props;

  const selectorData = useSelector(invoiceDataSelector);
  const { creditPaymentEnabled, achPaymentEnabled, remainingBalance } = selectorData;

  const [useCardToPay, toggleUseCardToPay] = useState(null);
  const [paymentAmount, setPaymentAmount] = useState('');

  useEffect(() => {
    toggleUseCardToPay(creditPaymentEnabled);
    setPaymentAmount(remainingBalance);
  }, [creditPaymentEnabled, remainingBalance]);

  return (
    <Card className="payments-tile-root">
      <CardContent>
        <div className="payments-top-section">
          <div style={{ width: '100%' }}>
            <div className="tile-header-text">
              Payment Method
            </div>
            <div className="payment-selection">
              {creditPaymentEnabled && (
              <button
                type="button"
                className={useCardToPay ? 'payment-type-active' : 'payment-type-inactive'}
                onClick={() => { toggleUseCardToPay(true); }}
              >
                <CreditCardIcon
                  style={{
                    height: '50px',
                    width: '70px',
                    color: useCardToPay ? '#00A9E0' : 'rgba(0, 0, 0, 0.5)',
                  }}
                />
                <p className={useCardToPay ? 'payment-type-text-active' : 'payment-type-text-inactive'}>Credit Card</p>
              </button>
              )}
              {achPaymentEnabled && (
              <button
                type="button"
                className={useCardToPay ? 'payment-type-inactive' : 'payment-type-active'}
                onClick={() => { toggleUseCardToPay(false); }}
              >
                <AccountBalanceIcon
                  style={{
                    height: '50px',
                    width: '70px',
                    color: useCardToPay ? 'rgba(0, 0, 0, 0.5)' : '#00A9E0',
                  }}
                />
                <p className={useCardToPay ? 'payment-type-text-inactive' : 'payment-type-text-active'}>Bank Account</p>
              </button>
              )}
            </div>
            { useCardToPay && (
              <CreditCardPayment
                invoiceID={invoiceID}
                currentPaymentAmount={paymentAmount}
                setCurrentPaymentAmount={(amount) => { setPaymentAmount(amount); }}
              />
            )}
            { !useCardToPay && (
              <ACHPayment
                invoiceID={invoiceID}
                currentPaymentAmount={paymentAmount}
                setCurrentPaymentAmount={(amount) => { setPaymentAmount(amount); }}
              />
            ) }
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

PaymentsTile.propTypes = {
  invoiceID: PropTypes.string.isRequired,
};

export default PaymentsTile;
